import styled from 'styled-components';

export const openPromotionMessagePopup = styled.div`
    cursor: pointer;
    transition:all 400ms;
    &:hover{
        transform: scale(1.1);
    }
 `;